import React from 'react';
import MuiChip, { ChipProps as MuiChipProps } from '@material-ui/core/Chip';
import { useStyles } from './styles';

export interface ChipProps extends MuiChipProps {
  active?: boolean;
}

export const Chip = ({ active, ...props }: ChipProps) => {
  const classes = useStyles({ active });
  return (
    <MuiChip
      classes={{
        root: classes.root,
        label: classes.label,
      }}
      {...props}
    />
  );
};
